import { Button, Icon, Layout, Text } from '@loadsmart/miranda-react'

import { type EffectiveCarrier } from '../../domain/Shipment'
import { TrackingMethod } from '../../domain/Tracking'
import { ProvidersBadge } from './ProvidersBadge'
import { ProviderCard } from './styles'

type EffectiveCarrierCardProps = {
  readonly effectiveCarrier: EffectiveCarrier
  readonly onClick: () => void
}

export function EffectiveCarrierCard({ effectiveCarrier, onClick }: EffectiveCarrierCardProps) {
  return (
    <ProviderCard onClick={onClick} filled>
      <Layout.Stack gap="spacing-4" justify="space-between" style={{ height: '100%' }}>
        <Layout.Stack gap="spacing-2">
          <Layout.Group align="center" justify="space-between">
            <ProvidersBadge methods={[TrackingMethod.ELD]} />
            <Button aria-label="Assign asset carrier" variant="icon-secondary" size="small">
              <Icon name="dots-vertical" size="20px" color="color-primary-60" />
            </Button>
          </Layout.Group>
          <Text variant="body-md-bold" color="color-primary-60">
            {effectiveCarrier.name}
          </Text>
          <Layout.Stack gap="none">
            <Text variant="body-sm" color="color-text-secondary">
              <Text variant="body-sm-bold" color="color-text-secondary">
                DOT:
              </Text>{' '}
              {effectiveCarrier.dot}
            </Text>
            <Text variant="body-sm" color="color-text-secondary">
              <Text variant="body-sm-bold" color="color-text-secondary">
                MC number:
              </Text>{' '}
              {effectiveCarrier.mc}
            </Text>
          </Layout.Stack>
        </Layout.Stack>
        <Text variant="body-sm" color="color-text-placeholder">
          Asset carrier information
        </Text>
      </Layout.Stack>
    </ProviderCard>
  )
}
